'use strict'

// How a multiple-choice value is shown on a view.
// Stored values are often a JSON array. Views never present that array text.
// comma is the default. newline and bullets are chosen per view column.

const { escapeHtml } = require('./html-sanitize')
const { flattenCardFields } = require('./card-layout')

const DISPLAYS = ['comma', 'newline', 'bullets']

function normalizeMultiselectDisplay (display) {

  return DISPLAYS.indexOf(display) >= 0 ? display : 'comma'
}

function primitiveList (values) {

  if (!Array.isArray(values)) return null
  if (!values.every((item) => item == null || typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean')) return null

  return values.filter((item) => item != null && item !== '').map((item) => String(item))
}

function readMultiselectItems (value) {

  if (Array.isArray(value)) return primitiveList(value)
  if (typeof value !== 'string') return null

  const trimmed = value.trim()

  if (trimmed.startsWith('"')) {

    try {

      const parsed = JSON.parse(trimmed)

      if (typeof parsed === 'string') return readMultiselectItems(parsed)
    } catch (error) {

      return null
    }

    return null
  }

  if (!trimmed.startsWith('[')) return null

  try {

    const parsed = JSON.parse(trimmed)

    if (typeof parsed === 'string') return readMultiselectItems(parsed)
    return primitiveList(parsed)
  } catch (error) {

    return null
  }
}

function joinItems (items, display) {

  const mode = normalizeMultiselectDisplay(display)

  if (mode === 'newline') return items.join('\n')
  if (mode === 'bullets') return items.map((item) => `• ${item}`).join('\n')

  return items.join(', ')
}

function formatMultiselectDisplay (value, display) {

  const items = readMultiselectItems(value)

  if (items) return joinItems(items, display)
  if (value == null || value === '') return ''
  if (Array.isArray(value)) return value.map((item) => String(item)).join(', ')

  return String(value)
}

function displayListValue (value, display) {

  const items = readMultiselectItems(value)

  if (!items) return null

  return joinItems(items, display)
}

function formatMultiselectHtml (value, display) {

  const items = readMultiselectItems(value)

  if (!items) return null
  if (!items.length) return ''

  const escaped = items.map((item) => escapeHtml(item))
  const mode = normalizeMultiselectDisplay(display)

  if (mode === 'newline') return escaped.join('<br>')

  if (mode === 'bullets') {

    return `<ul class="multiselect-display">${escaped.map((item) => `<li>${item}</li>`).join('')}</ul>`
  }

  return escaped.join(', ')
}

function listDisplayMap (view) {

  const map = Object.create(null)

  for (const field of flattenCardFields(view && view.components)) {

    if (!field || !field.uniqueTitle) continue

    map[field.uniqueTitle] = normalizeMultiselectDisplay(field.multiselectDisplay)
  }

  return map
}

function assignMultiselectDisplay (component, mode) {

  if (!component || typeof component !== 'object') return component

  if (mode === 'newline' || mode === 'bullets') component.multiselectDisplay = mode
  else delete component.multiselectDisplay

  return component
}

module.exports = {
  DISPLAYS,
  normalizeMultiselectDisplay,
  readMultiselectItems,
  formatMultiselectDisplay,
  displayListValue,
  formatMultiselectHtml,
  listDisplayMap,
  assignMultiselectDisplay
}
